<template>
  <div style="display: none">
    <slot v-if="ready"></slot>
  </div>
</template>

<script>
import { ref, onMounted, onBeforeUnmount, inject, markRaw, nextTick } from 'vue'
import { InjectionKeys, Utilities } from '@vue-leaflet/vue-leaflet'
import L from 'leaflet'
import 'leaflet.markercluster'

export default {
  name: 'LMarkerClusterGroup',
  props: { options: { type: Object, default: () => ({}) } },
  emits: ['ready'],
  setup(props, { emit, expose }) {
    const ready = ref(false)
    const leafletObject = ref(null)

    const addLayerToParent = inject(InjectionKeys.AddLayerInjection)
    const removeLayerFromParent = inject(InjectionKeys.RemoveLayerInjection)

    // Children resolve these at setup(); the bodies are swapped in on mount.
    const addLayer = Utilities.provideLeafletWrapper(InjectionKeys.AddLayerInjection)
    const removeLayer = Utilities.provideLeafletWrapper(InjectionKeys.RemoveLayerInjection)

    onMounted(async () => {
      const group = markRaw(L.markerClusterGroup(props.options))
      leafletObject.value = group

      Utilities.updateLeafletWrapper(addLayer, (layer) => group.addLayer(layer.leafletObject))
      Utilities.updateLeafletWrapper(removeLayer, (layer) => group.removeLayer(layer.leafletObject))

      addLayerToParent({ leafletObject: group })

      ready.value = true
      await nextTick()
      emit('ready', group)
    })

    onBeforeUnmount(() => {
      if (leafletObject.value) removeLayerFromParent({ leafletObject: leafletObject.value })
    })

    expose({ leafletObject })
    return { ready, leafletObject }
  }
}
</script>
